import React from "react";
import StaticPage from "./StaticPage";
import { CheckCircle2 } from "lucide-react";
const plans = [
  { name: "Starter", price: "₹0", tag: "Free for year 1", features: ["Up to 500 students", "Core procurement", "Parent commerce", "Email support"] },
  { name: "Growth", price: "₹9,999/mo", tag: "Popular", features: ["Up to 3000 students", "All Starter features", "Vendor scoring", "Priority support"] },
  { name: "Enterprise", price: "Custom", tag: "Trust groups", features: ["Unlimited students", "ERP integration", "SLA", "Dedicated CSM"] },
];
export default function Pricing() {
  return (
    <StaticPage title="Simple, transparent pricing" subtitle="Free for the first academic year. No credit card required.">
      <div className="not-prose grid md:grid-cols-3 gap-6 mt-4">
        {plans.map((p) => (
          <div key={p.name} data-testid={`plan-${p.name.toLowerCase()}`} className="sl-card p-6">
            <div className="text-xs uppercase tracking-wider text-brand-blue font-bold">{p.tag}</div>
            <h3 className="font-heading font-semibold text-xl mt-2">{p.name}</h3>
            <div className="text-3xl font-heading font-bold mt-3 text-slate-900">{p.price}</div>
            <ul className="mt-5 space-y-2 text-sm text-slate-600">
              {p.features.map((f) => <li key={f} className="flex items-center gap-2"><CheckCircle2 size={16} className="text-brand-green" /> {f}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </StaticPage>
  );
}
